import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LoginService } from '@ebw-monorepo/login';
import { lastValueFrom, Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ConfigService } from '../services/config.service';
import { RouterService } from '../services/router.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private _configService: ConfigService,
    private _authService: AuthService,
    private _loginService: LoginService,
    private _routerService: RouterService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree> {
    const isLoggedIn = this._loginService.userIsLoggedIn();
    if (isLoggedIn) {
      if (!this._authService.automateRefreshAlreadyTriggered$.getValue()) {
        const now: any = new Date();
        const expire_date = this._loginService.getTokenExpireDate();
        const isoDate: any = expire_date ? new Date(expire_date) : now;
        const diffInMilliseconds = isoDate - now;
        const diffInSeconds = Math.floor(diffInMilliseconds / 1000);
        const secondsToRefresh = diffInSeconds > 5 ? diffInSeconds : 0;
        this._authService.automateRefresh(secondsToRefresh);
        this._authService.automateRefreshAlreadyTriggered$.next(true);
      }
      // la prima volta le config le recupera qui se non ci sono
      const baseConfiguration = this._configService.getConfiguration();
      !baseConfiguration && (await lastValueFrom(this._configService.getAllConfigurations()));
      // ammetto la navigazione
      return true;
    }
    // altrimenti reindirizzo alla pagina di login
    this._routerService.navigateTo('login');
    return false;
  }
}
